/*
 * hn-promo-bar.js — ticks the countdown that sections/hn-promo-bar.liquid has
 * already rendered, and retires the bar the moment the campaign ends.
 *
 * The bar arrives from the server complete and correct: the remaining days,
 * hours, minutes and seconds are computed in Liquid and printed into the HTML.
 * Nothing here is required for the bar to look right on the first paint, which
 * is the point — this file is deferred, and a shopper on a slow connection sees
 * a finished bar rather than a placeholder.
 *
 * Two jobs only:
 *
 *   1. Advance the numbers once a second.
 *   2. Remove the bar when the end instant passes, because Shopify caches
 *      storefront HTML and a page served from that cache can outlive the
 *      campaign by a few minutes. Without this, a shopper sits looking at
 *      00 : 00 : 00 : 00 on an offer that has closed.
 *
 * Every tick recomputes from Date.now() against the absolute end instant rather
 * than decrementing a counter. A decrementing counter drifts, and it drifts
 * worst in exactly the case that matters: a backgrounded tab, where browsers
 * throttle timers to once a minute and then hand back a bar claiming there are
 * twenty minutes left when there are none.
 */
(function () {
  'use strict';

  var bar = document.getElementById('hn-promo');
  if (!bar) return;

  var STORAGE_PREFIX = 'hn-promo-closed:';
  var campaign = bar.getAttribute('data-campaign') || 'promo';

  /* ---- closing -------------------------------------------------------- */

  function storage() {
    /*
     * Safari in private mode, and any browser set to block site data, throws on
     * the first touch of localStorage rather than returning null. A promotion
     * bar is not worth a thrown exception that stops the rest of this file, so
     * every access is guarded and the feature simply degrades to "does not
     * remember", which is the correct behaviour when there is nowhere to store
     * the answer.
     */
    try {
      return window.localStorage;
    } catch (e) {
      return null;
    }
  }

  function alreadyClosed() {
    var store = storage();
    if (!store) return false;
    try {
      return store.getItem(STORAGE_PREFIX + campaign) === '1';
    } catch (e) {
      return false;
    }
  }

  function remove() {
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
    bar = null;
  }

  if (alreadyClosed()) {
    remove();
    return;
  }

  var closeBtn = bar.querySelector('[data-hn-promo-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      var store = storage();
      if (store) {
        try {
          store.setItem(STORAGE_PREFIX + campaign, '1');
        } catch (e) {
          /* Quota or a blocked store — closing still works for this page view. */
        }
      }
      remove();
    });
  }

  /* ---- whole-bar link ------------------------------------------------- */

  var href = bar.getAttribute('data-href');
  if (href) {
    bar.addEventListener('click', function (event) {
      /*
       * The bar can also carry a real <a> button and a close button. Both handle
       * their own click, so anything that originated inside one of them is left
       * alone rather than being followed twice or followed instead of closed.
       */
      if (event.target.closest('a, button')) return;
      window.location.href = href;
    });
  }

  /* ---- the countdown -------------------------------------------------- */

  var endAttr = bar.getAttribute('data-end');
  if (!endAttr) return;

  var endMs = parseInt(endAttr, 10) * 1000;
  if (!isFinite(endMs) || endMs <= 0) return;

  var timer = bar.querySelector('[data-hn-promo-timer]');
  var out = {
    days: bar.querySelector('[data-hn-promo-days]'),
    hours: bar.querySelector('[data-hn-promo-hours]'),
    minutes: bar.querySelector('[data-hn-promo-minutes]'),
    seconds: bar.querySelector('[data-hn-promo-seconds]')
  };

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function write(el, text) {
    /*
     * Comparing before writing keeps the seconds tile from invalidating the
     * whole bar's paint once a second when nothing above it has changed.
     */
    if (el && el.textContent !== text) el.textContent = text;
  }

  function tick() {
    var left = Math.floor((endMs - Date.now()) / 1000);

    if (left <= 0) {
      remove();
      clearInterval(handle);
      return;
    }

    write(out.days, String(Math.floor(left / 86400)));
    write(out.hours, pad(Math.floor(left / 3600) % 24));
    write(out.minutes, pad(Math.floor(left / 60) % 60));
    write(out.seconds, pad(left % 60));
  }

  if (!timer) return;
  var handle = setInterval(tick, 1000);
  tick();

  /*
   * A throttled background tab can be minutes stale by the time it is looked at
   * again, and the first repaint the shopper sees would otherwise be the old
   * number. Catching the tab coming back puts the bar right before it is read.
   */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tick();
  });
})();
